import { FareData, Segments, RawFareData } from "./types";

export enum AirLineCategory {
  ZERO_COMMISION = "Zero Commision",
}

export enum HotelCategory {
  ZERO_COMMISION = "Zero Commision",
}

export const titleList = [
  { label: "Mr.", value: "Mr." },
  { label: "Mrs.", value: "Mrs." },
  { label: "Miss.", value: "Miss." },
];
export const childrenTitle = [
  { label: "Miss", value: "Miss" },
  { label: "Master", value: "Master" },
];

export const coorporateList = [
  { label: "abc", value: "abc", id: 1 },
  { label: "aaa", value: "aaa", id: 2 },
  { label: "sss", value: "sss", id: 3 },
];

export const roleList = [
  { label: "EWTS", value: "EWTS" },
  { label: "STS", value: "STS" },
];

export const branchList = [
  { label: "EWTS", value: "EWTS" },
  { label: "STS", value: "STS" },
];

export const statusList = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const flightOptions = [
  { label: "One way", value: "One way" },
  { label: "Round Trip", value: "Round Trip" },
];

export type List = {
  label: string;
  value: string;
};

export const airlineLogos: Record<string, any> = {
  "6E": require("../../src/images/6E (1).png"), //Indigo
  QP: require("../../src/images/QP.png"), //Akasa Air
  AI: require("../../src/images/AI.png"), //Air India
  IX: require("../../src/images/IX.png"), //Air India Express
  SG: require("../../src/images/SG.png"), //SpiceJet
};

export const airlines = [
  { label: "Emirates", value: "Emirates" },
  { label: "Air India", value: "Air India" },
  { label: "IndiGo", value: "IndiGo" },
  { label: "SpiceJet", value: "SpiceJet" },
  { label: "Flydubai", value: "Flydubai" },
  { label: "Vistara", value: "Vistara" },
  { label: "Air Arabia", value: "Air Arabia" },
  { label: "Go First", value: "Go First" },
  { label: "Qatar Airways", value: "Qatar Airways" },
  { label: "Etihad Airways", value: "Etihad Airways" },
];
export const travelClass = [
  "Economy",
  "Premium Economy",
  "Business",
  "First Class",
];

export const superAdminRole = [
  {
    label: "Sub Admin",
    value: "5",
  },
];

export const categoryType = [
  { label: "Commission", value: "Commission" },
  { label: "Markup", value: "Markup" },
];
export const CRSName = [
  { label: "CSPA", value: "CSPA" },
  { label: "CSQA", value: "CSQA" },
];
export const AirportType = [
  { label: "Dom.", value: "Dom." },
  { label: "Intl.", value: "Intl." },
];
export const Category = [
  { label: "LSC", value: "LSC" },
  { label: "FSC", value: "FSC" },
];

export const flightClass = [
  { label: "Economy", value: "Economy" },
  { label: "FirstClass", value: "FirstClass" },
  { label: "Both", value: "Both" },
];
export const flatType = [
  { label: "Pax per Itinery", value: "Pax per Itinery" },
  { label: "Flat Fare", value: "Pax per Trip" },
];
export const fareType = [
  { label: "Percent fare", value: "Percent fare" },
  { label: "Flat Fare", value: "Flat Fare" },
];

export const percentageType = [
  { label: "BF + YQ", value: "BF + YQ" },
  { label: "GRF", value: "GRF" },
];
export const validFor = [
  { label: "Whichever Higher", value: "Whichever Higher" },
  { label: "Whichever Lower", value: "Whichever Lower" },
];

// Hotel commission

export const supplierType = [
  { label: "All", value: "All" },
  { label: "CSTNXT", value: "CSTNXT" },
];

export const hotelType = [
  { label: "Domestic", value: "Domestic" },
  { label: "International", value: "International" },
];

export const assignType = [
  { label: "Pax Per Booking", value: "Pax Per Booking" },
  { label: "Room Per Booking", value: "Room Per Booking" },
  { label: "Pax Per Night", value: "Pax Per Night" },
  { label: "Room Per Night", value: "Room Per Night" },
];

export const basedOnCommission = [
  {
    label: "Airline",
    value: "Airline",
  },
  {
    label: "Category",
    value: "Category",
  },
];

export const TopupType = [
  {
    label: "Prepaid",
    value: "prepaid",
  },
  {
    label: "Postpaid",
    value: "postpaid",
  },
];

export const PaymentMode = [
  {
    label: "Cash Deposit",
    value: "Cash Deposit",
  },
  {
    label: "Bank Transfer",
    value: "Bank Transfer",
  },
  {
    label: "Cheque",
    value: "cheque",
  },
  {
    label: "Net Transfer",
    value: "Net Transfer",
  },
  {
    label: "PG Network",
    value: "PG Network",
  },
];

export const PaymentStatusOptions = [
  { value: "pending", label: "Pending" },
  { value: "otp_pending", label: "OTP Verification Pending" },
  { value: "admin_review", label: "Admin Review" },
  { value: "admin_otp_pending", label: "Admin OTP Verification Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];
export const PriorityStatus = [
  { label: "High", value: "High" },
  { label: "Medium", value: "Medium" },
  { label: "Low", value: "Low" },
];

export const CouponType = [
  { label: "Percentage", value: "percent" },
  { label: "Fixed Amount", value: "fixed" },
];

export const VoucherStatusOptions = [
  { label: "Draft", value: "draft" },
  { label: "Active", value: "active" },
  { label: "Disabled", value: "disabled" },
];
export const VoucherStatusFilterOptions = [
  { label: "Draft", value: "draft" },
  { label: "Active", value: "active" },
  { label: "Expired", value: "expired" },
  { label: "Disabled", value: "disabled" },
];

export const AppliesToOptions = [
  { label: "Flight", value: "flight" },
  { label: "Hotel", value: "hotel" },
  { label: "Both", value: "both" },
];

// Complete ITU-T E.164 country calling codes (as of 2025)
// Note: Many codes cover multiple countries (e.g., +1 = US, Canada, Caribbean).
export const COUNTRY_CODES = new Set([
  "1",
  "7",
  "20",
  "27",
  "30",
  "31",
  "32",
  "33",
  "34",
  "36",
  "39",
  "40",
  "41",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "81",
  "82",
  "84",
  "86",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "98",
  "211",
  "212",
  "213",
  "216",
  "218",
  "220",
  "221",
  "222",
  "223",
  "224",
  "225",
  "226",
  "227",
  "228",
  "229",
  "230",
  "231",
  "232",
  "233",
  "234",
  "235",
  "236",
  "237",
  "238",
  "239",
  "240",
  "241",
  "242",
  "243",
  "244",
  "245",
  "246",
  "248",
  "249",
  "250",
  "251",
  "252",
  "253",
  "254",
  "255",
  "256",
  "257",
  "258",
  "260",
  "261",
  "262",
  "263",
  "264",
  "265",
  "266",
  "267",
  "268",
  "269",
  "290",
  "291",
  "297",
  "298",
  "299",
  "350",
  "351",
  "352",
  "353",
  "354",
  "355",
  "356",
  "357",
  "358",
  "359",
  "370",
  "371",
  "372",
  "373",
  "374",
  "375",
  "376",
  "377",
  "378",
  "379",
  "380",
  "381",
  "382",
  "383",
  "385",
  "386",
  "387",
  "389",
  "420",
  "421",
  "423",
  "500",
  "501",
  "502",
  "503",
  "504",
  "505",
  "506",
  "507",
  "508",
  "509",
  "590",
  "591",
  "592",
  "593",
  "594",
  "595",
  "596",
  "597",
  "598",
  "599",
  "670",
  "672",
  "673",
  "674",
  "675",
  "676",
  "677",
  "678",
  "679",
  "680",
  "681",
  "682",
  "683",
  "685",
  "686",
  "687",
  "688",
  "689",
  "690",
  "691",
  "692",
  "800",
  "808",
  "850",
  "852",
  "853",
  "855",
  "856",
  "870",
  "878",
  "880",
  "881",
  "882",
  "883",
  "886",
  "888",
  "960",
  "961",
  "962",
  "963",
  "964",
  "965",
  "966",
  "967",
  "968",
  "970",
  "971",
  "972",
  "973",
  "974",
  "975",
  "976",
  "977",
  "979",
  "992",
  "993",
  "994",
  "995",
  "996",
  "998",
]);
